import { MenuSectionItemFragment, ServiceItemFragment } from '@client/graphql/types/graphql.ts';
import { getFragmentData } from '@client/graphql/types';
import { MenuSectionFragment } from '@packages/network-graphql/common/menu-section-fragment.ts';

export interface ServiceBySection {
  section: MenuSectionItemFragment | null | undefined;
  items: ServiceItemFragment[];
}

export function groupServiceItemsBySection(
  items: readonly ServiceItemFragment[],
  sections: readonly MenuSectionItemFragment[]
): ServiceBySection[] {
  const map: Record<string, ServiceBySection> = {};

  map[''] = { section: null, items: [] };
  for (const section of sections) {
    map[section.id] = {
      section: section,
      items: [],
    };
  }

  for (const item of items) {
    const section = getFragmentData(MenuSectionFragment, item.section);
    const key = section?.id ?? '';

    map[key]?.items.push(item);
  }

  if (map[''].items.length === 0) {
    delete map[''];
  }

  return Object.values(map);
}
